module.exports = __webpack_public_path__ + "img/BIRD SHADES LIME.d013cc5.svg";